/** "31 Jul 2026" — for dates where the time of day doesn't matter. */
export function formatDate(dateTime) {
  if (!dateTime) return '';
  return new Date(dateTime).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** "15:42" — for feeds where a date separator above already says which day. */
export function formatTime(dateTime) {
  if (!dateTime) return '';
  return new Date(dateTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

/**
 * "Today", "Yesterday", "12 August" — the heading over a day's worth of messages.
 *
 * Named days for the two that need no working out. Anything older gets the date,
 * without the year: a board that has been running since January reads worse with
 * "2026" on every separator than it does without it.
 */
export function formatDayHeading(dateTime) {
  if (!dateTime) return '';
  const d = new Date(dateTime);
  const midnight = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const days = Math.round((midnight(new Date()) - midnight(d)) / 86400000);
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
}

/** "Fri 31 Jul 23:00" — kick-off times shown to players. */
export function formatKickoff(dateTime) {
  if (!dateTime) return '';
  const d = new Date(dateTime);
  const day = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${day} ${time}`;
}

/**
 * "in 3 hours", "in 2 days", "closing now" — how long is left, for deadlines.
 *
 * Relative rather than absolute because a deadline is only ever read as "have I got
 * time?", and answering that from "Sat 16 Aug 11:30" is work the reader should not
 * have to do. Past and imminent both come back as "closing now": there is no useful
 * difference between a deadline that went a minute ago and one going in a minute, and
 * "3 minutes late" is a worse thing to read than either.
 */
export function formatCountdown(dateTime) {
  if (!dateTime) return '';
  const minutes = Math.round((new Date(dateTime).getTime() - Date.now()) / 60000);
  if (minutes < 60) return 'closing now';
  if (minutes < 120) return 'in an hour';
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `in ${hours} hours`;
  const days = Math.round(hours / 24);
  return days === 1 ? 'tomorrow' : `in ${days} days`;
}
